/* Eagle Leather — product-card stock count.
   Cards render the total stock across variants (snippets/product-deliverytime.liquid).
   - Choosing a variant in the card's quick-buy select shows that variant's stock (stays until changed).
   - Hovering or keyboard-focusing a color swatch shows that color's stock; leaving the swatches restores
     the current value. */
(function () {
  'use strict';

  function card(el) { return el && el.closest ? el.closest('.product-card') : null; }

  function stockData(c) {
    var s = c && c.querySelector('script.el-stock-data');
    if (!s) return null;
    if (!s._elData) {
      try { s._elData = JSON.parse(s.textContent); } catch (e) { s._elData = []; }
    }
    return s._elData;
  }

  function countEl(c) { return c && c.querySelector('.el-stock-count'); }

  function render(span, n) {
    span.textContent = n > 0 ? span.getAttribute('data-el-tpl').replace('__N__', n) : span.getAttribute('data-el-oos');
  }

  function restore(c) {
    var span = countEl(c);
    if (!span) return;
    if (span.hasAttribute('data-el-selected')) {
      render(span, parseInt(span.getAttribute('data-el-selected'), 10));
    } else {
      span.textContent = span.getAttribute('data-el-total-text');
    }
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.matches || !t.matches('select[name="id"]')) return;
    var c = card(t), d = stockData(c), span = countEl(c);
    if (!d || !span) return;
    var id = parseInt(t.value, 10);
    for (var i = 0; i < d.length; i++) {
      if (d[i].id === id) {
        span.setAttribute('data-el-selected', d[i].q);
        render(span, d[i].q);
        return;
      }
    }
  });

  function colorStock(d, label) {
    var sum = 0, found = false;
    for (var i = 0; i < d.length; i++) {
      if (d[i].o.indexOf(label) > -1) { sum += Math.max(d[i].q, 0); found = true; }
    }
    return found ? sum : null;
  }

  function onSwatch(e) {
    var li = e.target.closest && e.target.closest('.product-card ul.check.color li');
    if (!li) return;
    var c = card(li), d = stockData(c), span = countEl(c);
    var a = li.querySelector('a[aria-label]');
    if (!d || !span || !a) return;
    var n = colorStock(d, a.getAttribute('aria-label'));
    if (n !== null) render(span, n);
  }

  function offSwatch(e) {
    var ul = e.target.closest && e.target.closest('.product-card ul.check.color');
    if (!ul || (e.relatedTarget && ul.contains(e.relatedTarget))) return;
    restore(card(ul));
  }

  document.addEventListener('mouseover', onSwatch);
  document.addEventListener('focusin', onSwatch);
  document.addEventListener('mouseout', offSwatch);
  document.addEventListener('focusout', offSwatch);
})();

/* Eagle Leather — shipping ETA from the Shipping policy settings (window.elShipping).
   Server renders "Pick up in store, or ships within 1 business day"; this refines the ship part to the
   actual day: "order by 12:30 PM PT to ship today", "ships tomorrow", or "ships Monday". */
(function () {
  'use strict';
  var cfg = window.elShipping;
  if (!cfg) return;

  function partsInTz(date) {
    var f = new Intl.DateTimeFormat('en-US', { timeZone: cfg.tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false, weekday: 'short' });
    var o = {};
    f.formatToParts(date).forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, m: +o.month, d: +o.day, h: +o.hour % 24, min: +o.minute };
  }
  function ymd(dt) { return dt.getUTCFullYear() + '-' + String(dt.getUTCMonth() + 1).padStart(2, '0') + '-' + String(dt.getUTCDate()).padStart(2, '0'); }
  function isShipDay(dt) { return cfg.shipDays.indexOf(dt.getUTCDay()) > -1 && cfg.closedDates.indexOf(ymd(dt)) === -1; }
  function nextShipDay(dt, n) {
    var d = new Date(dt.getTime());
    while (n > 0) { d.setUTCDate(d.getUTCDate() + 1); if (isShipDay(d)) n--; }
    return d;
  }
  function cutoffLabel() {
    var h = cfg.cutoffHour, ap = h >= 12 ? 'PM' : 'AM', h12 = h % 12 || 12;
    return h12 + ':' + String(cfg.cutoffMinute).padStart(2, '0') + ' ' + ap + ' ' + cfg.tzLabel;
  }

  function eta() {
    var p = partsInTz(new Date());
    var today = new Date(Date.UTC(p.y, p.m - 1, p.d));
    var beforeCutoff = p.h < cfg.cutoffHour || (p.h === cfg.cutoffHour && p.min < cfg.cutoffMinute);
    if (isShipDay(today) && beforeCutoff) return 'Order by ' + cutoffLabel() + ' to ship today';
    var ship = nextShipDay(today, cfg.handlingDays);
    var tomorrow = new Date(today.getTime()); tomorrow.setUTCDate(tomorrow.getUTCDate() + 1);
    if (ymd(ship) === ymd(tomorrow)) return 'Ships tomorrow';
    return 'Ships ' + ship.toLocaleDateString('en-US', { weekday: 'long', timeZone: 'UTC' });
  }

  function apply(root) {
    var els = (root || document).querySelectorAll('[data-el-ship-eta]');
    if (!els.length) return;
    // Local buyers first (get it now), then the shipping promise: "Pick up in store, or ships Monday"
    var ship = eta();
    var text = cfg.pickupText ? cfg.pickupText + ', or ' + ship.charAt(0).toLowerCase() + ship.slice(1) : ship;
    for (var i = 0; i < els.length; i++) els[i].textContent = text;
  }

  window.elShippingEta = eta;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { apply(); });
  else apply();
  // Re-apply when the theme swaps in new markup (filters, pagination, variant change, quick shop)
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      for (var j = 0; j < muts[i].addedNodes.length; j++) {
        var n = muts[i].addedNodes[j];
        if (n.nodeType === 1 && (n.matches('[data-el-ship-eta]') || n.querySelector('[data-el-ship-eta]'))) { apply(n.parentNode || n); }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Eagle Leather — short description "Read more".
   The short description (content.short_description metafield) links to #section-info. Instead of only
   jumping there, open the description (mobile accordion tab + the theme's "Read more" clamp) and move
   focus to it, so one click shows the full text. */
(function () {
  'use strict';
  function container() {
    var anchor = document.getElementById('section-info');
    if (!anchor) return null;
    // The theme moves the id onto a span.anchor appended inside the original element
    return anchor.classList.contains('anchor') ? anchor.parentElement : anchor;
  }
  function expand(box) {
    var tab = box.closest('.tabs-inner') ? box.closest('.tabs-inner').parentElement : null;
    var header = tab ? tab.querySelector(':scope > .tabs-header') : null;
    if (header && !header.classList.contains('toggle')) header.click();
    var clamp = box.querySelector('.m6lm');
    if (!clamp) return;
    var more = clamp.parentElement.querySelector(':scope > .has-link-more a.link-more, :scope > p a.link-more');
    if (more && !more.parentElement.parentElement.classList.contains('link-more-clicked')) more.click();
  }
  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('a[href="#section-info"]') : null;
    if (!link || link.closest('nav, .tabs-header')) return;
    var box = container();
    if (!box || box.contains(link)) return;
    e.preventDefault();
    expand(box);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // span.anchor is already offset for the sticky header (theme CSS), so scroll to it directly
    var target = document.getElementById('section-info') || box;
    var top = target.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
    if (!box.hasAttribute('tabindex')) box.setAttribute('tabindex', '-1');
    box.focus({ preventScroll: true });
  });
})();

/* Eagle Leather — align product-card rows on desktop.
   Cards in the same visual row get the same height for each piece of information (title, rating, stock,
   price, swatches), so a two-line title or a missing rating no longer shifts the rest of that card.
   Cards without a rating get an empty placeholder in the rating slot when a neighbor has one.
   Mobile (≤760px) is left alone. */
(function () {
  'use strict';
  var desktop = window.matchMedia('(min-width: 761px)');
  var SLOTS = ['h3', '.r6rt', 'p.stock.list-hide', 'p.price', 'ul.check.color'];
  var LISTS = 'ul.l4cl:not(.list):not(.hr):not(.box):not(.upsell):not(.category)';

  function cardsOf(list) {
    var out = [];
    for (var i = 0; i < list.children.length; i++) {
      var li = list.children[i];
      if (li.classList && li.classList.contains('product-card') && li.offsetParent !== null) out.push(li);
    }
    return out;
  }

  function info(card) {
    // The card's text column: first <div> after the figure (the second, .static, holds price and swatches)
    for (var i = 0; i < card.children.length; i++) {
      var c = card.children[i];
      if (c.tagName === 'DIV' && !c.classList.contains('static')) return c;
    }
    return null;
  }

  function placeholders(cards) {
    var any = cards.some(function (c) { return c.querySelector('.r6rt:not(.el-r6rt-ph)'); });
    cards.forEach(function (c) {
      var ph = c.querySelector('.el-r6rt-ph');
      if (!any || c.querySelector('.r6rt:not(.el-r6rt-ph)')) { if (ph) ph.remove(); return; }
      if (ph) return;
      var box = info(c);
      if (!box) return;
      ph = document.createElement('p');
      ph.className = 'r6rt el-r6rt-ph';
      ph.setAttribute('aria-hidden', 'true');
      var stock = box.querySelector(':scope > p.stock.list-hide');
      box.insertBefore(ph, stock || null);
    });
  }

  function rows(cards) {
    var map = {}, keys = [];
    cards.forEach(function (c) {
      var k = Math.round(c.getBoundingClientRect().top);
      if (!map[k]) { map[k] = []; keys.push(k); }
      map[k].push(c);
    });
    return keys.map(function (k) { return map[k]; });
  }

  function reset(list) {
    var els = list.querySelectorAll('[data-el-eq]');
    for (var i = 0; i < els.length; i++) { els[i].style.minHeight = ''; els[i].removeAttribute('data-el-eq'); }
  }

  function align(list) {
    reset(list);
    var cards = cardsOf(list);
    if (!desktop.matches) {
      cards.forEach(function (c) { var ph = c.querySelector('.el-r6rt-ph'); if (ph) ph.remove(); });
      return;
    }
    if (cards.length < 2) return;
    placeholders(cards);
    rows(cards).forEach(function (row) {
      if (row.length < 2) return;
      SLOTS.forEach(function (sel) {
        var els = [], max = 0;
        row.forEach(function (c) {
          var el = c.querySelector(sel);
          if (el) { els.push(el); max = Math.max(max, el.getBoundingClientRect().height); }
        });
        if (els.length < 2) return;
        els.forEach(function (el) { el.style.minHeight = max + 'px'; el.setAttribute('data-el-eq', ''); });
      });
    });
  }

  var queued = false;
  function run() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      var lists = document.querySelectorAll(LISTS);
      for (var i = 0; i < lists.length; i++) align(lists[i]);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(run, 150); });
  if (desktop.addEventListener) desktop.addEventListener('change', run);
  // Filters, sorting, pagination and "load more" swap cards in; re-align when cards are added
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      for (var j = 0; j < muts[i].addedNodes.length; j++) {
        var n = muts[i].addedNodes[j];
        if (n.nodeType === 1 && (n.classList.contains('product-card') || (n.querySelector && n.querySelector('.product-card')))) { run(); return; }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.elAlignCards = run;
})();
